import Model from "./Model";

export default class Curso extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }
}
